import { Util } from '@grandvision/forms'

// TODO: make this (together with the rest of the checkout) less Ireland specific.
/**
 *  Italy specific form validation rules
 */
export const isPhoneNumber = (value: string): boolean => {
  return REGEX.PHONE_NUMBER.test(value)
}

export const isMobilePhoneNumber = (value: string): boolean => {
  return REGEX.MOBILE_PHONE_NUMBER.test(value)
}

export const isValidBirthDate = (value: string): boolean => {
  const dates = value.split('-')
  return Util.validations.isValidBirthDate(dates[2], dates[1], dates[0])
}

export const isValidPostalCode = (value: string): boolean => {
  return (
    Util.validations.minLength(6)(value) &&
    Util.validations.maxLength(8)(value) &&
    // Must contain one space
    /^[^\s]*\s[^\s]*$/.test(value) &&
    // Must contain one letter
    /.*[aA-zZ].*/.test(value) &&
    // Must contain one digit
    /.*[0-9].*/.test(value)
  )
}

const REGEX = {
  PHONE_NUMBER: /^\d{1,13}$/,
  MOBILE_PHONE_NUMBER: /^08\d{8}$/,
  WHITESPACE: /\s/g,
}
